// generated by genversion
export var version = '4.2.4';
//# sourceMappingURL=version.js.map